import React from 'react';

import Awards from '../../components/awards';

// import './index.css';

const Component = () => {
    return (
        <div className="publications">
            <h3>Awards &amp; Honours</h3>
            <Awards />
        </div>
    );
};

export default Component;
